// Marketplace chosen in the Business Settings location combo.
// Set during render so settings API calls in the same commit, including psp_status,
// use the new location before the settings marketplace finishes loading.
let selectedSettingsMarketplaceId: number | undefined;

export const setSelectedSettingsMarketplaceId = (marketplaceId: number | undefined): void => {
    selectedSettingsMarketplaceId = marketplaceId;
};

export const getSelectedSettingsMarketplaceId = (): number | undefined => selectedSettingsMarketplaceId;
